export default __webpack_public_path__ + "static/media/Clutch of the Dragon King.09d8e682.jpg";